export default "__VITE_ASSET__CYQIpTIf__"